import { Stack, Grid, Typography, Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { useEffect, useState } from 'react';
import PageHeading from '../../Components/PageHeading';
import PageLoader from '../../Components/PageLoader';
import { useSelector } from 'react-redux';
import CultService from '../../Services/CultService';
import toast from 'react-hot-toast';
import { AppColors } from '../../Utils/helper/AppColors';
import DataNotFound from '../../Components/DataNotFound';
import addie from '../../Assets/Image/addie.svg';
import { AgentCard } from './Components/AgentCard';


// const agents1 = [
// 	{
// 		name: 'Remo',
// 		type: 'AI Customer Service Recruiter',
// 		description:
// 			'Remo is an AI recruiter skilled in conducting comprehensive candidate screenings with a focus on communication, problem-solving, and role-specific competencies tailored for customer service roles.',
// 		purpose: 'Screen candidates for support roles with empathy and clarity.Sales Rep Recruiter',
// 		language: 'US English',
// 		totalHours: 3000,
// 		agentType: 'Inbound Agent',
// 	},
// 	{
// 		name: 'Remo',
// 		type: 'AI Sales Rep Recruiter',
// 		description:
// 			'Remo is an AI recruiter specializing in evaluating candidates for sales roles by assessing persuasive communication, objection handling, target orientation, and interpersonal skills.',
// 		purpose: 'Evaluate candidates for sales roles focused on persuasion and drive.',
// 		language: 'US English',
// 		totalHours: 2300,
// 		agentType: 'Campaign Agentd',
// 	},
// 	{
// 		name: 'Remo',
// 		type: 'AI Customer Service Recruiter',
// 		description:
// 			'Remo is an AI recruiter skilled in conducting comprehensive candidate screenings with a focus on communication, problem-solving, and role-specific competencies tailored for customer service roles.',
// 		purpose: 'Screen candidates for support roles with empathy and clarity.Sales Rep Recruiter',
// 		language: 'US English',
// 		totalHours: 3000,
// 		agentType: 'Inbound Agent',
// 	},
// 	{
// 		name: 'Remo',
// 		type: 'AI Sales Rep Recruiter',
// 		description:
// 			'Remo is an AI recruiter specializing in evaluating candidates for sales roles by assessing persuasive communication, objection handling, target orientation, and interpersonal skills.',
// 		purpose: 'Evaluate candidates for sales roles focused on persuasion and drive.',
// 		language: 'US English',
// 		totalHours: 2300,
// 		agentType: 'Inbound Agent',
// 	},
// 	{
// 		name: 'Remo',
// 		type: 'AI Customer Service Recruiter',
// 		description:
// 			'Remo is an AI recruiter skilled in conducting comprehensive candidate screenings with a focus on communication, problem-solving, and role-specific competencies tailored for customer service roles.',
// 		purpose: 'Screen candidates for support roles with empathy and clarity.Sales Rep Recruiter',
// 		language: 'US English',
// 		totalHours: 3000,
// 		agentType: 'Inbound Agent',
// 	},
// 	{
// 		name: 'Remo',
// 		type: 'AI Sales Rep Recruiter',
// 		description:
// 			'Remo is an AI recruiter specializing in evaluating candidates for sales roles by assessing persuasive communication, objection handling, target orientation, and interpersonal skills.',
// 		purpose: 'Evaluate candidates for sales roles focused on persuasion and drive.',
// 		language: 'US English',
// 		totalHours: 2300,
// 		agentType: 'Inbound Agent',
// 	},
// ];

export default function AgentsList() {
	const company = useSelector((state) => state?.app?.company);
	const [agents, setAgents] = useState([]);
	const [filteredAgents, setFilteredAgents] = useState([]);
	console.log('agents', agents);
	const [loading, setLoading] = useState(false);
	const [agentType, setAgentType] = useState('Campaign Agent');
	const [isPickedForShowMore,setIsPickedForShowMore] = useState(null);

	const AssistantBtns = [
		{
			code: 'Campaign Agents',
			type: 'Campaign Agent',
			Component: null,
			props: {},
		},
		{
			code: 'Inbound Agents',
			type: 'Inbound Agent',
			Component: null,
			props: {},
		},
	];

	const fetchAssistants = async () => {
		try {
			setLoading(true);
			const [responsePublicAssistants, responsePrivateAssistants] = await Promise.all([
				CultService.getIncomingCallAssistants({ params: { companyId: company?._id } }),
				CultService.getAllModelAssistanst({ params: { companyId: company?._id } }),
			]);

			console.log('Fetch assistants response:', responsePublicAssistants, '- ', responsePrivateAssistants);
			if (responsePublicAssistants?.data?.success) {
				let publicAssistants = responsePublicAssistants?.data?.data?.incomingCallAssistants;
				let privateAssistants = responsePrivateAssistants?.data?.data;

				publicAssistants = publicAssistants.map((assistant) => ({
					...assistant,
					agentType: 'Inbound Agent',
				}));

				privateAssistants = privateAssistants.map((assistant) => ({
					...assistant,
					agentType: 'Campaign Agent',
				}));

				let allAgents = [...publicAssistants, ...privateAssistants ]; // Added multiple copies of privateAssistants
				setAgents(allAgents);
				toast.success('Assistants fetched successfully');
			}
		} catch (error) {
			console.error('Error fetching assistants:', error);
			toast.error('Something Went Wrong Please try again later');
		} finally {
			setLoading(false);
		}
	};

	const handleChangeAssitents = (event, newValue) => {
		if (newValue !== null) {
			setIsPickedForShowMore(null);
			setAgentType(newValue);
		}
	};

	useEffect(() => {
		let filtered = agents.filter((agent) => agent?.agentType === agentType);
		setFilteredAgents(filtered);
	}, [agentType, agents , isPickedForShowMore ]);

	useEffect(() => {
		if (company?._id) {
			fetchAssistants();
		}
	}, [company?._id]);


	return (
		<Stack gap={3} padding={2}>
			<PageHeading title="Agents" />

			<Box>
				<ToggleButtonGroup
					size="small"
					value={agentType}
					exclusive
					border={0}
					onChange={handleChangeAssitents}
					sx={theme => ({ 
						width: '100%', height : { xs : 'none' , md :'45px'} ,
						border: `1px solid ${AppColors?.lightest_grey}`,
						borderRadius: '14px 14px 0 0', 
						borderBottom: 0 })}
				>
					{AssistantBtns?.map((tab, index) => (
						<ToggleButton
							key={index}
							sx={(theme) => ({
								textTransform: 'none',
								px: 2,
								alignItems: 'center',
								width: { xs : '50%'  },
								height: '100%',
								border: 0,
								borderRadius: '14px 0px 0 0',
								backgroundColor: AppColors.NEW_BACKGROUND4,
																'&.Mui-selected': {
										backgroundColor: theme.palette.secondary.orange || theme.palette.primary.lightest_shade,
										color: theme.palette.secondary.orange || theme.palette.primary.darker_primary,
										'&:hover': { backgroundColor: theme.palette.secondary.orange || theme.palette.primary.lightest_shade },
									},
								'&:hover': { opacity : 0.9 },
							})}
							value={tab?.type}
						>
							<Typography
								fontSize={14}
								fontWeight={600}
								lineHeigh
								lineHeight={'150%'}
								sx={(theme) =>
										tab?.type === agentType  ? { color: theme.palette.primary.white } : { color: theme.palette.secondary.orange }
									}
							>
								{tab?.code}
							</Typography>
						</ToggleButton>
					))}
				</ToggleButtonGroup>

				<Box sx={theme => ({ maxHeight: 'calc(100vh - 135px)', minHeight: 'calc(100vh - 150px)', overflowY: 'auto', py: 2 , px : 3 , border: `1px solid ${AppColors?.lightest_grey}`, borderRadius: '0 0 14px 14px' })}>
					{filteredAgents?.length === 0 ? (
						<DataNotFound text="Sorry! No Agents Found" />
					) : (
						<Grid container spacing={3}>
							{filteredAgents.map((agent, index) => (
								// bug - > lg < md
								<Grid item xs={12} sm={6} md={4} xl={3} key={index}>
									<AgentCard agent={agent} agentType={agent?.agentType}  img={addie} isPickedForShowMore={isPickedForShowMore}  setIsPickedForShowMore={setIsPickedForShowMore} />
								</Grid>
							))}
						</Grid>
					)}
				</Box>
			</Box>

			{loading && <PageLoader />}
		</Stack>
	);
}
